
import React from "react";
import styles from './ActivitiesNotification.module.css';
import MessageComp from "../MessageComp/MessageComp";
import { delActivityNotification } from "../../store/notificationSlice";

import { useSelector, useDispatch } from "react-redux";
import toast, { Toaster } from 'react-hot-toast';
import { AiOutlineCheck } from "react-icons/ai";

const ActivitiesNotification = ()=>{

    const messageDeletedSucesfully = ()=> toast.success("Message successfully deleted", {
        icon: <AiOutlineCheck />,
        iconTheme:  {
            primary:'',
            secondary: ''
        }
    });

    const activitiesNote = useSelector(state=> state.notifications.msgs.activities);

    const dispatch = useDispatch();

    return(<>

            <Toaster 
                gutter={10} 
                position="top-right"
                reverseOrder={false}
                className={styles.toaster_comp_}
                toastOptions={{
                    success: {
                        style: {
                            background: 'rgb(148, 246, 246)',
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: '13.4px',
                            borderRadius: '3px',
                            padding: '1rem'
                        }
                    },
                    error: {
                        style: {
                            background: 'red'
                        }
                    },
                }}
                containerStyle= {{
                    right: 20
            }}
            />
        <div className={styles.asdfghjkl_asdfghjkl}>
            
            <div className={styles.AllNotifications_wrapper__}>
                

                {
                    activitiesNote.map( (val, ind)=> (
                        <MessageComp key={ind} 
                        heading={val.heading}
                        txt={val.txt}
                        date={val.date}
                        time={val.time}
                        deleteProps={()=>{
                            dispatch( delActivityNotification({ id: val.id }) )
                            messageDeletedSucesfully()
                        }}
                        />
                    ) )
                }


            </div>

        </div>
    </>)
}

export default ActivitiesNotification;